import { Stack } from '@chakra-ui/react';
import React from 'react';
export const SimpleModalView = ({
  modalHead,
  modalContent
}) => {
  return /*#__PURE__*/React.createElement(Stack, {
    flex: 1,
    spacing: 1,
    h: "full"
  }, modalHead, modalContent);
};